import { cn, useIsTextTruncated } from "@istari-frontend/shared";
import { Slot as SlotPrimitive } from "radix-ui";
import * as React from "react";
import { useRef } from "react";

import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

type TruncatedTextProps = {
  tooltipText?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  asChild?: boolean;
};

export function TruncatedText({ tooltipText, className, style, children, asChild = false }: TruncatedTextProps) {
  const overflowRef = useRef<HTMLElement>(null);
  const isTruncated = useIsTextTruncated(overflowRef, tooltipText, Boolean(tooltipText));

  const truncateClassName = cn(
    "block max-w-full min-w-0 truncate",
    !asChild && children && "[&>*]:block [&>*]:max-w-full [&>*]:min-w-0 [&>*]:truncate",
    className,
  );

  const content = asChild ? (
    <SlotPrimitive.Slot ref={overflowRef} className={truncateClassName} style={style}>
      {children}
    </SlotPrimitive.Slot>
  ) : (
    <span ref={overflowRef} className={truncateClassName} style={style}>
      {children ?? tooltipText}
    </span>
  );

  if (!tooltipText) return content;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{content}</TooltipTrigger>
      {isTruncated ? <TooltipContent>{tooltipText}</TooltipContent> : null}
    </Tooltip>
  );
}
